import { coalesce } from "./ObjectUtils";
import { uniqBy } from "lodash/array";
import React from "react";

export const MEASUREMENT_FILTER_COL_KEY = "Spalten-1";
export const MEASUREMENT_COL_KEY = "measurement";
export const STATUS_FILTER_COL_KEY = "Spalten-2";
export const AREA_FILTER_COL_KEY = "projekt-1";

export const filter = (rows, filterStr, questionAnswer, measureSubstr) => {
  // get all answers from the column
  let filteredAnswers;
  if (measureSubstr) {
    const substr = filterStr.match(/^\b(Maßnahme)\s+[0-9]{1,2}.[0-9]{1,2}/)[0];
    filteredAnswers = questionAnswer.answers.filter((answer) => answer.text.startsWith(substr));
  } else {
    filteredAnswers = questionAnswer.answers.filter((answer) => answer.text === filterStr);
  }
  // get all the rows with the respective label from answers
  return rows.filter((row) => filteredAnswers.find((answer) => answer.label === row.name));
};

export const filterRows = (rows, measureFilter, statusFilter, areaFilter, questionAnswer, setFilteredRows) => {
  let result = rows;
  if (measureFilter) {
    result = filter(result, measureFilter, questionAnswer, true);
  }
  if (statusFilter) {
    result = filter(result, statusFilter, questionAnswer);
  }
  if (areaFilter) {
    result = filter(result, areaFilter, questionAnswer);
  }

  if (setFilteredRows) {
    setFilteredRows(result);
  } else {
    return result;
  }
};

export const renderFilterOptions = (column, questionAnswer, intl) => {
  let answers = coalesce(questionAnswer.answers, []).filter((answer) => answer.colLabel === column.name);
  answers = uniqBy(answers, "text");
  let result = [];

  result.push(
    <option value={""} key={"first"}>
      {intl.formatMessage({ id: "user.surveyView.dropdown.choose" })}
    </option>
  );
  answers.forEach((answer, i) => {
    if (result.indexOf(answer) === -1) {
      result.push(
        <option value={answer.text} key={i}>
          {answer.text}
        </option>
      );
    }
  });

  return result;
};
